import React from 'react'
import UseAdminGetAllCoupons from '../../CustomHooks/Admin/UseAdminGetAllCoupons'
import Pagination from '../Layout/Pagination'
import AdminCouponList from './AdminCouponList';
import { Link } from 'react-router-dom';
import { Button, Spinner } from 'react-bootstrap';

const AdminAllCouponsComp = () => {
  const [loading, AllCoupons, pagesCount, onPress, SearchValue, ChangeInputSearch] = UseAdminGetAllCoupons()
  return (
    <>
      <div className='d-flex flex-row justify-content-between m-3  mt-5 align-items-center'>
        <h3 className='fw-bold'>All Coupons</h3>
        <Link to="/admin/addcoupon">
          <Button className='dark-bg border-0 px-4 py-3'>Add New Coupon</Button>
        </Link>
      </div>
      <div className='d-flex flex-row justify-content-between mx-3 align-items-center'>
        <input type='text' className='form-control h-60 fs-20 fw-bold' placeholder='Search by coupon Name' value={SearchValue} onChange={ChangeInputSearch} />
      </div>

      {loading === true ? (<div className='d-flex justify-content-center align-items-center mt-5 pt-5'>
        <Spinner animation="border" variant="danger" />
      </div>) :
        (AllCoupons && AllCoupons.results >= 1 ? (<div className='w-100 px-3 pt-3 pb-5'>
          {AllCoupons && AllCoupons.data ? (AllCoupons.data.map((item, index) => <AdminCouponList item={item} key={index} />)) : null}
          {pagesCount && pagesCount > 1 ? (<Pagination pageCount={pagesCount} onPress={onPress} />) : null}
        </div>) :
          <div className='d-flex justify-content-center align-items-center flex-column h-100'>
            <h3 className='alert alert-danger'>No coupons, Add new coupon to show</h3>
            <Link to="/admin/addcoupon">
              <Button className='dark-bg border-0 px-4 py-3'>Add New Coupon</Button>
            </Link>
          </div>
        )}
    </>


  )
}

export default AdminAllCouponsComp
